module.exports = __webpack_public_path__ + "img/stopped.8eec314b.svg";